import React, { useCallback, useEffect, useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";

import { Box, Button, ErrorMsg, Grid, OtpInput, Text } from "atoms";

const validationSchema = Yup.object().shape({
  otp: Yup.string().required(),
});

export const OtpForm = ({
  onSubmit,
  onResend,
  email,
  loading,
  error,
  resetError,
}) => {
  const [timerValue, setTimerValue] = useState(30);
  const [resendLoading, setResetLoading] = useState(false);
  const [resendError, setResendError] = useState("");

  useEffect(() => {
    const timer =
      timerValue > 0 && setInterval(() => setTimerValue(timerValue - 1), 1000);
    return () => clearInterval(timer);
  }, [timerValue]);

  const onResendHandler = useCallback(() => {
    email && setResetLoading(true);
    email &&
      onResend(email)
        .then((success) => {
          success && setResendError(success);
        })
        .catch((e) => {
          setResendError(e?.message);
        })
        .finally(() => {
          setResetLoading(false);
          setTimeout(() => {
            setResendError("");
            setTimerValue(30);
          }, 3000);
        });
  }, [onResend, email]);

  return (
    <Box>
      <Text
        fontSize="2rem"
        color="primary.900"
        fontFamily="NeometricBold"
        mb="2rem"
      >
        Enter OTP
      </Text>
      <Text fontSize="1.6rem" color="neutral.800" mb="4rem">
        Please enter the 6 digit code sent to{" "}
        <Text as="span" fontFamily="NeometricMedium">
          {email}
        </Text>
      </Text>
      <Formik
        initialValues={{
          otp: "",
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue }) => {
          return (
            <Form>
              <Grid gridGap="2.4rem">
                <OtpInput
                  id="otp"
                  name="otp"
                  value={values?.otp}
                  onChange={(val) => {
                    setFieldValue("otp", val);
                    error && resetError();
                  }}
                />
                {error && <ErrorMsg text={error} />}
                <Button
                  my="2rem"
                  width="100%"
                  variant="primary"
                  height="4.8rem"
                  type="submit"
                  loading={loading}
                >
                  Submit
                </Button>
              </Grid>
            </Form>
          );
        }}
      </Formik>
      <Box>
        {timerValue > 0 && (
          <Text
            color="secondary.700"
            textAlign="center"
            fontFamily="NeometricMedium"
            fontSize="1.6rem"
          >
            00:{timerValue < 10 && "0"}
            {timerValue} sec
          </Text>
        )}

        {!timerValue && !resendLoading && !resendError && (
          <Text
            fontSize="1.6rem"
            color="neutral.800"
            fontFamily="NeometricMedium"
            textAlign="center"
          >
            Did't receive an email? &nbsp;
            <Text
              as="span"
              color="secondary.700"
              cursor="pointer"
              onClick={onResendHandler}
            >
              Resend
            </Text>
          </Text>
        )}

        {!timerValue && resendLoading && (
          <Text
            fontSize="1.6rem"
            color="neutral.800"
            fontFamily="NeometricMedium"
            textAlign="center"
          >
            Re-sending new OTP ....
          </Text>
        )}

        {!timerValue && !resendLoading && resendError === true && (
          <Text
            fontSize="1.6rem"
            color="neutral.800"
            fontFamily="NeometricMedium"
            textAlign="center"
          >
            OTP Sent
          </Text>
        )}
        {!timerValue && !resendLoading && resendError && (
          <ErrorMsg text={resendError} textAlign="center" />
        )}
      </Box>
    </Box>
  );
};
